import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../../contexts/LanguageContext';
import { showToast } from '../../utils/toast';
import { postApi } from '../../utils/api/api';
import DeleteImages from '../Common/DeleteImages';
import { FaDollarSign, FaBox } from "react-icons/fa";

const AddInventoryFormFilament = ({ selectedOption }) => {
  const { t } = useLanguage();
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    filament_categories: '',
    filament_priceperkg_from: '',
    filament_priceperkg_to: '',
    filament_quantity_from: '',
    filament_quantity_to: '',
    semi_full_dull: '',
    texturized: '',
    filament_dennier_from: '',
    filament_dennier_to: '',
    filament_no_from: '',
    filament_no_to: '',
    filament_twist: '',
    roto_twist_intermingle: '',
    images: [],
    certificate: null,
    ipi: '',
    quality_grade: '',
    category: '',
    sub_category: '',
    end_use: '',
    technology: '',
    ply: '',
    application: '',
    yarn_speciality: ''
  });
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(false);

  // Options for dropdowns
  const filamentCategoriesOptions = ['POY/FOY', 'Viscose', 'Nylon'];
  const semiFullDullOptions = [
    { value: 'ROTO', label: 'ROTO' },
    { value: 'Draw Twist', label: 'Draw Twist' },
    { value: 'Airtex', label: 'Airtex' },
    { value: 'Mono', label: 'Mono' },
    { value: 'Kota', label: 'Kota' },
    { value: 'Super Glue', label: 'Super Glue' },
    { value: 'Glue', label: 'Glue' }
  ];
  const texturizedOptions = [
    { value: 'Bright', label: 'Bright' },
    { value: 'Catonic', label: 'Catonic' },
    { value: 'Easy Dyable', label: 'Easy Dyable' }
  ];
  const qualityGradeOptions = ["A", "B"];
  const categoryOptions = ['Cotton','Polyester','Viscose','Linen'];
  const endUseOptions = ['Weaving','Knitting/Hosiery','Sewing Thread','Embroidery','Filtration'];
  const technologyOptions = ['Ring','Open End','Vortex','Airjet','Wet','Friction'];
  const plyOptions = ['Single', 'Double', 'Multi-Fold'];
  const applicationOptions = ['Warp','Weft','Warp&Weft','Circular','Filter'];
  const yarnSpecialityOptions = ['Slub','High-twist','Organic','BCI','Neps','Siro/ Elli Twist','Injected Slub','Super High Twist','TFO'];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
    setErrors((prev) => ({ ...prev, [name]: '' }));
  };

  const handleFileChange = (e, field) => {
    const file = e.target.files[0];
    if (file && field === 'certificate' && !file.type.includes('pdf')) {
      setErrors((prev) => ({ ...prev, [field]: 'Please upload a PDF file only.' }));
      return;
    }
    setFormData((prev) => ({ ...prev, [field]: file }));
    setErrors((prev) => ({ ...prev, [field]: '' }));
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    const invalidFiles = files.filter(file => !['image/jpeg', 'image/png'].includes(file.type));

    if (invalidFiles.length > 0) {
      setErrors((prev) => ({ ...prev, images: 'Please upload only JPG or PNG files.' }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      images: [...prev.images, ...files],
    }));
    if (files.length > 0) {
      setErrors((prev) => ({ ...prev, images: '' }));
    }
  };

  const handleImageDelete = (index) => {
    setFormData((prev) => {
      const updatedImages = prev.images.filter((_, i) => i !== index);
      return { ...prev, images: updatedImages };
    });
  };

  const handleCertificateDelete = () => {
    setFormData((prev) => ({ ...prev, certificate: null }));
  };

  const validateForm = () => {
    const { name, filament_categories, filament_priceperkg_from, filament_priceperkg_to, 
            filament_quantity_from, filament_quantity_to, semi_full_dull, texturized,
            filament_dennier_from, filament_dennier_to, filament_no_from, filament_no_to,
            images, certificate, description,quality_grade } = formData;
    const newErrors = {};

    // if (!filament_categories?.trim()) newErrors.filament_categories = 'Category is required';
    if (!formData.filament_categories?.trim()) newErrors.filament_categories = 'Category is required';
    if (!quality_grade?.trim()) newErrors.quality_grade = t('inventoryErrors.qualityGradeRequired', 'Quality grade is required.');
    // if (!filament_priceperkg_from || isNaN(filament_priceperkg_from)) newErrors.filament_priceperkg_from = 'Enter a valid price';
    // if (!filament_priceperkg_to || isNaN(filament_priceperkg_to)) newErrors.filament_priceperkg_to = 'Enter a valid price';

    /*if (!filament_priceperkg_from || isNaN(filament_priceperkg_from)) newErrors.filament_priceperkg_from = 'Enter a valid price';
    if (!filament_priceperkg_to || isNaN(filament_priceperkg_to)) newErrors.filament_priceperkg_to = 'Enter a valid price';
    if (parseFloat(filament_priceperkg_from) > parseFloat(filament_priceperkg_to)) newErrors.filament_priceperkg_to = 'Price To must be greater than or equal to Price From';
    if (!filament_quantity_from || isNaN(filament_quantity_from)) newErrors.filament_quantity_from = 'Enter a valid quantity';
    if (!filament_quantity_to || isNaN(filament_quantity_to)) newErrors.filament_quantity_to = 'Enter a valid quantity';
    if (parseFloat(filament_quantity_from) > parseFloat(filament_quantity_to)) newErrors.filament_quantity_to = 'Quantity To must be greater than or equal to Quantity From';
    if (!semi_full_dull?.trim()) newErrors.semi_full_dull = 'Semi/Full Dull is required';
    if (!texturized?.trim()) newErrors.texturized = 'Texturized is required';
    if (!filament_dennier_from || isNaN(filament_dennier_from)) newErrors.filament_dennier_from = 'Enter a valid dennier';
    if (!filament_dennier_to || isNaN(filament_dennier_to)) newErrors.filament_dennier_to = 'Enter a valid dennier';
    if (parseFloat(filament_dennier_from) > parseFloat(filament_dennier_to)) newErrors.filament_dennier_to = 'Dennier To must be greater than or equal to Dennier From';
    if (!filament_no_from || isNaN(filament_no_from)) newErrors.filament_no_from = 'Enter a valid number';
    if (!filament_no_to || isNaN(filament_no_to)) newErrors.filament_no_to = 'Enter a valid number';
    if (parseFloat(filament_no_from) > parseFloat(filament_no_to)) newErrors.filament_no_to = 'Number To must be greater than or equal to Number From';*/
    // if (images.length === 0) newErrors.images = 'Please upload at least one image';
    // if (!certificate) newErrors.certificate = 'Please upload a certificate';

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) {
      console.log("Validation Errors:", errors);
      showToast('error', t('errors.validationFailed', 'Please correct the errors in the form.'));
      return;
    };
    setLoading(true);
    try {
      const payload = { ...formData, form_type: 'Filament', price_type: selectedOption };

      const formDataPayload = new FormData();
      Object.keys(payload).forEach((key) => {
        if (key === 'images') {
          payload.images.forEach((image) => formDataPayload.append('images[]', image));
        } else if (key === 'certificate') {
          formDataPayload.append('certificate', payload.certificate);
        } else {
          formDataPayload.append(key, payload[key]);
        }
      });

      await postApi('/seller/create-product', formDataPayload);
      showToast('success', t('success.inventoryAdded', 'Inventory added successfully!'));
      navigate('/seller-dashboard');
    } catch (err) {
      showToast('error', err.message || t('errors.submitFailed', 'Failed to submit the form.'));
    } finally {
      setLoading(false);
    }
  };

  // Helper function to render form fields
  const renderField = (label, name, type = 'text', options = [], required = false, placeholder = '') => (
    <div className="form-group">
      <label htmlFor={name}>
        {label} {required && <span className="text-danger">*</span>}
      </label>
      {type === 'select' ? (
        <select
          id={name}
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          className={`form-control form-select  ${errors[name] ? 'is-invalid' : ''}`}
        >
          <option value="">{`Select ${label}`}</option>
          {options.map((option, index) => (
            <option 
              key={index} 
              value={option.value ? option.value : option}
            >
              {option.label ? option.label : option}
            </option>
          ))}
        </select>
      ) : type === 'textarea' ? (
        <textarea
          id={name}
          name={name}
          value={formData[name]}
          onChange={handleInputChange}
          maxLength="500"
          className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
          rows="4"
          placeholder={placeholder}
        ></textarea>
      ) : (
        <div className="input-with-icon">
          <input
            type={type}
            id={name}
            name={name}
            value={formData[name]}
            onChange={handleInputChange}
            className={`form-control ${errors[name] ? 'is-invalid' : ''}`}
            placeholder={placeholder || label}
          />
          {/*{(name === 'filament_priceperkg_from' || name === 'filament_priceperkg_to') && (
            <span className="input-icon">
              {selectedOption === "$ / kg" ? (
                <FaDollarSign size={20} color="green" />
              ) : (
                <FaBox size={20} color="blue" />
              )}
            </span>
          )}*/}
        </div>
      )}
      {errors[name] && <div className="invalid-feedback">{errors[name]}</div>}
    </div>
  );

  return (
    <div className="add-inventory-container common-form-container">
      <div className="form-card">
        <div className="form-body">
          <form onSubmit={handleSubmit}>
            <div className="form-grid">
              <div className="row full-width">
                <div className="col-md-6"> {renderField('Category', 'filament_categories', 'select', filamentCategoriesOptions, true)}</div>
              </div>
             {/* <div className="row full-width">
                <div className="col-md-6">
                  {renderField('Price Per KG From', 'filament_priceperkg_from', 'number', [], false, 'e.g., 100')}
                </div>
                <div className="col-md-6">
                  {renderField('Price Per KG To', 'filament_priceperkg_to', 'number', [], false, 'e.g., 200')}
                </div>
              </div>*/}

              <div className="row full-width">
                <div className="col-md-6">
                  {renderField('Quantity(Box) From', 'filament_quantity_from', 'number', [], false, 'e.g., 10')}
                </div>
                <div className="col-md-6">
                  {renderField('Quantity(Box) To', 'filament_quantity_to', 'number', [], false, 'e.g., 20')}
                </div>
              </div>
              <div className="row full-width">
                <div className="col-md-6">
                  {renderField('Semi/Full Dull', 'semi_full_dull', 'select', semiFullDullOptions, false)}
                </div>
                <div className="col-md-6">
                  {renderField('Texturized', 'texturized', 'select', texturizedOptions, false)}
                </div>
              </div>
              <div className="row full-width">
                <div className="col-md-6">
                  {renderField('Dennier From', 'filament_dennier_from', 'number', [], false, 'e.g., 50')}
                </div>
                <div className="col-md-6">
                  {renderField('Dennier To', 'filament_dennier_to', 'number', [], false, 'e.g., 100')}
                </div>
              </div>

              <div className="row full-width">
                <div className="col-md-6">
                  {renderField('No. Of Filament From', 'filament_no_from', 'number', [], false, 'e.g., 10')}
                </div>
                <div className="col-md-6">
                  {renderField('No. Of Filament To', 'filament_no_to', 'number', [], false, 'e.g., 20')}
                </div>
              </div>
              <div className="row full-width">
                <div className="col-md-6">
                  {renderField('Filament Twist', 'filament_twist', 'text', [], false, 'Enter filament twist')}
                </div>
                <div className="col-md-6">
                  {renderField('Roto Twist Intermingle', 'roto_twist_intermingle', 'text', [], false, 'Enter roto twist intermingle')}
                </div>
              </div>

              {/* Common Fields Section */}
              <div className='card p-2 full-width' id="commonFields">
                <div className='row'>
                  {/* <div className='col-lg-6'>
                    {renderField('Category', 'category', 'select', categoryOptions)}
                  </div>
                  <div className='col-lg-6'>
                    {renderField('End Use', 'end_use', 'select', endUseOptions)}
                  </div>
                  <div className='col-lg-6'>
                    {renderField('Technology', 'technology', 'select', technologyOptions)}
                  </div>
                  <div className='col-lg-6'>
                    {renderField('Ply', 'ply', 'select', plyOptions)}
                  </div>
                  <div className='col-lg-6'>
                    {renderField('Application', 'application', 'select', applicationOptions)}
                  </div>
                  <div className='col-lg-6'>
                    {renderField('Yarn Speciality', 'yarn_speciality', 'select', yarnSpecialityOptions)}
                  </div> */}
                  <div className='col-lg-6'>
                    {renderField('IPI', 'ipi', 'text', [], false, 'e.g., 50')}
                  </div>
                  <div className='col-lg-6'>
                    {renderField('Quality Grade', 'quality_grade', 'select', qualityGradeOptions,true)}
                  </div>
                  <div className='col-lg-6'>
                    <div className="form-group full-width">
                      <label htmlFor="images">
                        Product Images  <span className="badge">JPG, PNG only</span>
                      </label>
                      <input
                        type="file"
                        id="images"
                        multiple
                        accept="image/jpeg, image/png"
                        onChange={handleImageChange}
                        className={`form-control ${errors.images ? 'is-invalid' : ''}`}
                      />
                      <DeleteImages images={formData.images} onDelete={handleImageDelete} />
                      {errors.images && <div className="invalid-feedback d-block">{errors.images}</div>}
                    </div>
                  </div>
                  <div className='col-lg-6'>
                    <div className="form-group full-width">
                      <label htmlFor="certificate">
                        Upload Certificate  <span className="badge">PDF only</span>
                      </label>
                      <input
                        type="file"
                        id="certificate"
                        accept="application/pdf"
                        onChange={(e) => handleFileChange(e, 'certificate')}
                        className={`form-control ${errors.certificate ? 'is-invalid' : ''}`}
                      />
                      {formData.certificate && (
                        <div className="certificate-preview">
                          <span>{formData.certificate.name}</span>
                          <button type="button" className="btn-delete-certificate" onClick={handleCertificateDelete}>
                            &times;
                          </button>
                        </div>
                      )}
                      {errors.certificate && <div className="invalid-feedback d-block">{errors.certificate}</div>}
                    </div>
                  </div>
    
                </div>
              </div>
            </div>

            {/* Submit Button */}
            <div className="form-actions">
              <button
                type="submit"
                className="submit-button"
                disabled={loading}
              >
                {loading ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
                    Submitting...
                  </>
                ) : (
                  'Add Inventory'
                )}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default AddInventoryFormFilament;